import React from "react";
import useOffers from "../adminDashboard/offers/useOffers";
import SimpleCarousel from "../adminDashboard/offers/components/SimpleCarousel";
import CustomLoading from "../../utils/LoadingIndicator/CustomLoading";

function HomePageOffers() {
  const {
    offersError,
    activeOffers: offers,
    isGettingActiveOffers,
  } = useOffers();

  const content = () => {
    if (isGettingActiveOffers) {
      return (
        <div className="flex justify-center items-center h-[500px]">
          <CustomLoading />
        </div>
      );
    }

    if (offersError) {
      return (
        <div className="text-center text-red-600 py-8">
          Error loading offers. Please try again later.
        </div>
      );
    }

    if (!offers?.length) {
      return <></>;
    }

    return (
      <div className="w-full" id="offers">
        <SimpleCarousel offers={offers} />
      </div>
    );
  };

  return content();
}

export default HomePageOffers;
